import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";

export const decryptWithAES = (ciphertext) => {
  const passphrase = process.env.REACT_APP_CIPHER_PASS;
  const bytes = AES.decrypt(ciphertext, passphrase);
  const originalText = bytes.toString(Utf8);
  return originalText;
};
